import { useEffect, useState } from "react";
import { FaPowerOff } from "react-icons/fa";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { CommonApiData, GetSession, RemoveSession, SetSession } from "../../EnvConfig/env_config";
import { setBranchCode, setOpen } from '../../Redux/Services/headerSlice';
import { InputBox, SelectInputBox } from "../CommonComponents/InputBox";
import Loader from "../CommonComponents/Loader";
import { ApiCall, DropDownData } from "../CommonComponents/CustomHooks";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { setLanguage, setTranslate } from "../../Redux/Services/LanuageSlice";
import Swal from 'sweetalert2';
const Header = () => {
    const dispatch = useDispatch()

    const [theme, setTheme] = useState(GetSession('localStorage', 'theme'))
    const { open } = useSelector((state) => state.header);
    let AuthData = CommonApiData();
    const BranchCode = GetSession('cookies', 'branchCode');
    const navigate = useNavigate()
    //const Lang = JSON.parse(localStorage.getItem('Language'))||'English'
    const [formData, setFormData] = useState({
        awbNumber: "",
       /* language: Lang,*/
       
    })
    const { language } = useSelector(state => state.lang)

    const Logout2 = async () => {
        await SetSession('cookies', 'loginSessionID', 'EXPIRED')
        let user = GetSession('cookies', 'user')
        await SetSession('cookies', 'user', { ...user, loginSessionID: 'EXPIRED' })
        await RemoveSession('cookies', 'branchCode')
        await localStorage.removeItem("translations")
        await localStorage.removeItem("Language")
        await dispatch(setLanguage('English'))
        navigate('/login');
    };

    const Logout = async () => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to logout?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DABE6D",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, logout!",
            cancelButtonText: "Cancel",
            keydownListenerCapture: true,
            stopKeydownPropagation: false,
            didOpen: () => {
                document.addEventListener('keydown', function (event) {
                    if (event.key === 'Y' || event.key === 'y') {
                        Swal.clickConfirm();
                    } else if (event.key === 'N' || event.key === 'n') {
                        Swal.clickCancel();
                    }
                });
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                await SetSession('cookies', 'token', 'EXPIRED')
                let user = GetSession('cookies', 'user')
                await SetSession('cookies', 'user', { ...user, loginSessionID: 'EXPIRED' })
                await RemoveSession('cookies', 'branchCode')
                await localStorage.removeItem("translations")
                await localStorage.removeItem("Language")
                await dispatch(setLanguage('English'))
                navigate('/login');
            }
        });
    };

    const LanuageTranslter = async (Value) => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/GetTranslationMasterData', { Language: Value })
        await dispatch(setSubLoading(false))
        if ( data.Status === 'SUCCESS') {
            const filteredData = data.Data.map(item => ({
                Keyword: item.Keyword,
                Value: item.Value
            }));
            dispatch(setTranslate(filteredData))
            localStorage.setItem('translations', JSON.stringify(filteredData));
           // console.log('Data stored in local storage:', filteredData);
            
        }
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus,);
        }
    }


    const handleSetBranch = (e) => {
        window.location.reload()
        dispatch(setBranchCode(e.target.value));
        SetSession('cookies', 'branchCode', e.target.value)
    }
    
    useEffect(() => {
        if (document && document.body) {
            document.body.classList.remove('light', 'dark');
            if (theme === 'dark') {
                document.body.classList.add('dark');
            } else {
                document.body.classList.add('light');
            }
        }
    }, [theme]);

    return (
        <>
            <header id="header" className="header fixed-top d-block d-md-flex align-items-center justify-content-between">
                <div className="d-flex justify-content-between">
                    <Link className="logo d-flex align-items-center">
                        <span className="logo">
                            <img src={`assets/img/${theme === 'light' ? 'mainlogo.png' : 'mainlogo-light.png'}`} alt="" height='50px' width='240px' />
                        </span>
                    </Link>
                    <i className="bi bi-list toggle-sidebar-btn" onClick={() => dispatch(setOpen(!open))} />
                </div>

                <div className="d-flex align-items-center px-2 justify-content-between">

                    {/*<SelectInputBox*/}
                    {/*    required={true}*/}
                    {/*    id='txtLanuage'*/}
                    {/*    value={language}*/}
                    {/*    divclassname='col-md-3 mb-1 cntrl-width mt-1 me-3'*/}
                    {/*    onChange={async (e) => {*/}
                    {/*        const newValue = e.target.value;*/}
                    {/*        dispatch(setLanguage(newValue))*/}
                    {/*        await LanuageTranslter(newValue);*/}
                    {/*        localStorage.setItem('Language', JSON.stringify(newValue));*/}
                    {/*    }}*/}
                    {/*>*/}
                      
                    {/*    {GetLanuage?.data?.dataList?.map((item, index) =>*/}
                    {/*        <option key={item.name + index} value={item.name}>{item.name}</option>*/}
                    {/*    )}*/}
                    {/*</SelectInputBox>*/}
                    <InputBox
                        id='Awb No'
                        divclassname='me-3'
                        type="text"
                        value={formData?.awbNumber ? formData?.awbNumber : ''}
                        onChange={(e) => {
                            setFormData({ ...formData, awbNumber: e.target.value })
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                             //   window.open(`/Tracking/Tracking/TrackingCN?awbNumber=${formData.awbNumber}`, '_blank');
                                navigate(`/Tracking?awbNumber=${formData.awbNumber}`);       
                                setFormData(prevData => ({
                                    ...prevData,
                                    awbNumber: ""
                                }))
                                e.preventDefault()
                            };
                        }}
                        PlaceHolderText="Awb No"
                        autoComplete="off"
                        maxLength='50'
                      
                    />
                    {/*<InputBox*/}
                    {/*    divclassname='me-3 branch_select'*/}
                    {/*    id='txtBranchCode'*/}
                    {/*    value={BranchCode}*/}
                    {/*    disabled={true}*/}
                    {/*    onChange={(e) => { handleSetBranch(e) }}*/}
                    {/*/>*/}
                    <div>
                        {theme === 'light' ?
                            <>
                                <MdDarkMode
                                    style={{ cursor: 'pointer' }}
                                    title='Dark'
                                    className='fs-3'
                                    onClick={(e) => {
                                        setTheme(theme === 'light' ? 'dark' : 'light')
                                        SetSession('localStorage', 'theme', theme === 'light' ? 'dark' : 'light')
                                    }}
                                /> </> :
                            <> <MdLightMode
                                title='Light'
                                className='fs-3'
                                style={{ cursor: 'pointer', color:'#DABE6D' }}
                                onClick={(e) => {
                                    setTheme(theme === 'light' ? 'dark' : 'light')
                                    SetSession('localStorage', 'theme', theme === 'light' ? 'dark' : 'light')
                                }}
                            /></>}
                    </div>
                    <ul className="d-flex gap-2 mt-3 align-items-center" >
                        <div className='user_headname' style={{ fontWeight: '600' }}>{AuthData?.LoginUserCode} : {AuthData?.User}</div>
                        <FaPowerOff style={{ color: 'red', fontSize: '22px', cursor: 'pointer' }} onClick={Logout} title='Logout' />
                    </ul>
                </div>
            </header>
            {false ? <Loader /> : <></>}
        </>
    )
}
export default Header